import { RangeValue } from '@common/types/queryState';
import { Flex, Text, TextField } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

interface FacetDatePickerProps {
    value?: RangeValue;
    onChange: (value: RangeValue) => void;
}

export const FacetDatePicker = ({ value, onChange }: FacetDatePickerProps) => {
    const { t } = useTranslation('facetingPanel');

    const formatForInput = (val: string | number | undefined) => {
        if (!val || typeof val !== 'string' || val.includes('NOW')) return '';
        return val.split('T')[0];
    };

    const formatToBackend = (dateStr: string, isEnd: boolean) => {
        if (!dateStr) return undefined;
        // Start of day for 'from', End of day for 'to'
        return isEnd ? `${dateStr}T23:59:59Z` : `${dateStr}T00:00:00Z`;
    };

    return (
        <Flex gap='3' align='center'>
            <Flex direction='column' style={{ flex: 1 }}>
                <Text size='1' color='gray' mb='1' weight='bold'>
                    {t('from')}
                </Text>

                <TextField.Root
                    type='date'
                    size='1'
                    value={formatForInput(value?.min)}
                    onChange={(event) =>
                        onChange({
                            ...value,
                            operator: 'inclusive',
                            min: formatToBackend(event.target.value, false),
                        })
                    }
                />
            </Flex>

            <Flex direction='column' style={{ flex: 1 }}>
                <Text size='1' color='gray' mb='1' weight='bold'>
                    {t('to')}
                </Text>

                <TextField.Root
                    type='date'
                    size='1'
                    value={formatForInput(value?.max)}
                    onChange={(event) =>
                        onChange({
                            ...value,
                            operator: 'inclusive',
                            max: formatToBackend(event.target.value, true),
                        })
                    }
                />
            </Flex>
        </Flex>
    );
};
